import React, { useState } from 'react';
import clsx from 'clsx';
import { ChevronDown } from 'lucide-react';
import SourceCard from './SourceCard';

/**
 * Collapsed by default — COO scans the answer, clicks "Show evidence" only
 * if they want to verify. Matches brief §5: text-first + toggle.
 */

export default function EvidenceToggle({ evidence }) {
  const [open, setOpen] = useState(false);

  if (!evidence) return null;

  return (
    <div data-drishti="evidence-toggle" className="mt-3">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="inline-flex items-center gap-1 rounded text-xs font-medium text-slate-600 hover:text-navy focus:outline-none focus:ring-2 focus:ring-accent"
      >
        <ChevronDown
          className={clsx(
            'h-3.5 w-3.5 transition-transform',
            open ? 'rotate-180' : 'rotate-0',
          )}
          aria-hidden="true"
        />
        {open ? 'Hide evidence' : 'Show evidence'}
      </button>

      {open ? (
        <div className="mt-2">
          <SourceCard evidence={evidence} />
        </div>
      ) : null}
    </div>
  );
}
